import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const CMF_EMAIL_MESSAGE_FETCH = createAsyncActionTypes('CMF_EMAIL_MESSAGE_FETCH');